import { ReceiptThemeFormValues } from './types';
import { DEFAULT_ASSET_URLS } from 'constants/constants';

export const defaultReceiptTheme: ReceiptThemeFormValues = {
  senderName: '',
  logo: DEFAULT_ASSET_URLS.LOGO,
  headerImage: DEFAULT_ASSET_URLS.RECEIPT_HEADER,
  publisherId: '',
  paymentReceiptTemplateName: '',
  refundReceiptTemplateName: '',
  subscriptionReceiptTemplateName: '',
  subscriptionRefundReceiptTemplateName: '',
  supportUrl: null
};
